import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
import search from "../views/search.vue";
import service from "../views/service.vue";
import list from "../views/list.vue";
import show from "../views/show.vue";
import softcity from "../views/softCity.vue";
import headbox from "../components/head.vue";
import footbox from "@/components/footer.vue";
import cdgk from "@/views/cdgk.vue";
import fzhj from "@/views/fzhj.vue";
import cycj from "@/views/cycj.vue";
import details from "@/views/details.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      title: "天府软件网",
    },
  },
  {
    path: "/search",
    name: "search",
    component: search,
    meta: {
      title: "全局搜索",
    },
  },
  {
    path: "/service",
    name: "service",
    component: service,
    meta: {
      title: "服务页",
    },
  },
  {
    path: "/szyw",
    name: "szyw",
    component: list,
    meta: {
      title: "时政要闻",
    },
  },
  {
    path: "/hyez",
    name: "hyez",
    component: list,
    meta: {
      title: "行业资讯",
    },
  },
  {
    path: "/tzgg",
    name: "tzgg",
    component: list,
    meta: {
      title: "通知公告",
    },
  },
  {
    path: "/cydt",
    name: "cydt",
    component: list,
    meta: {
      title: "产业动态",
    },
  },
  {
    path: "/rjmc",
    name: "rjmc",
    component: list,
    meta: {
      title: "软件名城",
    },
  },
  {
    path: "/cdgk",
    name: "cdgk",
    component: cdgk,
    meta: {
      title: "成都概况",
    },
  },
  {
    path: "/fzhj",
    name: "fzhj",
    component: fzhj,
    meta: {
      title: "发展环境",
    },
  },
  {
    path: "/cycj",
    name: "cycj",
    component: cycj,
    meta: {
      title: "产业成就",
    },
  },
  {
    path: "/jqql",
    name: "jqql",
    component: list,
    meta: {
      title: "建圈强链",
    },
  },
  {
    path: "/qlhd",
    name: "qlhd",
    component: list,
    meta: {
      title: "20+系列活动",
    },
  },
  {
    path: "/qyfw",
    name: "qyfw",
    component: list,
    meta: {
      title: "企业服务",
    },
  },
  {
    path: "/hytj",
    name: "hytj",
    component: list,
    meta: {
      title: "行业统计",
    },
  },
  {
    path: "/rbrc",
    name: "rbrc",
    component: list,
    meta: {
      title: "“蓉贝”人才",
    },
  },
  {
    path: "/rqh",
    name: "rqh",
    component: list,
    meta: {
      title: "软洽会",
    },
  },
  {
    path: "/rjds",
    name: "rjds",
    component: list,
    meta: {
      title: "软件大赛",
    },
  },
  {
    path: "/zthd",
    name: "zthd",
    component: list,
    meta: {
      title: "专题活动",
    },
  },
  {
    path: "/cyzc",
    name: "cyzc",
    component: list,
    meta: {
      title: "产业政策",
    },
  },
  {
    path: "/cyfw",
    name: "cyfw",
    component: list,
    meta: {
      title: "产业服务",
    },
  },
  {
    path: "/xxtxds",
    name: "xxtxds",
    component: list,
    meta: {
      title: "信息通信大会",
    },
  },
  {
    path: "/gjj",
    name: "gjj",
    component: list,
    meta: {
      title: "国家级",
    },
  },
  {
    path: "/scj",
    name: "scj",
    component: list,
    meta: {
      title: "四川级",
    },
  },
  {
    path: "/cdj",
    name: "cdj",
    component: list,
    meta: {
      title: "成都市",
    },
  },
  {
    path: "/show",
    name: "show",
    component: show,
    meta: {
      title: "天府软件网",
    },
  },
  {
    path: "/softcity",
    name: "softcity",
    component: softcity,
    meta: {
      title: "软件名城",
    },
  },
  {
    path: "/details",
    name: "details",
    component: details,
    meta: {
      title: "天府软件网",
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
export default router;
